import { call, put, takeLatest } from 'redux-saga/effects';

import { apiCallAsync } from 'src/redux/api/saga';
import { UPDATE_USER_SETTINGS_ACTION } from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { updateUserSettingsFailed, updateUserSettingsSuccess } from './actions';

export function* updateUserSettingsSaga(action: ViewAction) {
  try {
    const { API_HOST } = yield import('src/constants');
    const response = yield call(
      apiCallAsync,
      `${API_HOST}/api/usersettings/`,
      action.payload,
      'put',
    );

    if (response.status === 200) {
      yield put(updateUserSettingsSuccess(response.data));
    } else {
      throw new Error('API call failed with status: ' + response.status);
    }
  } catch (error) {
    console.error('Failed to update user settings:', error);
    yield put(updateUserSettingsFailed(error.message || error.toString()));
  }
}

export function* watchUpdateUserSettingsSaga() {
  yield takeLatest(UPDATE_USER_SETTINGS_ACTION, updateUserSettingsSaga);
}
